import { createContext } from 'react'

const AppContext = createContext({
  isMobile: false,
  isLoggedIn: false,
})

export default AppContext
